/** iOS アプリ（WKWebView ラッパー）内か。iOS 側は UA 末尾に `__is_iOS_App` を付けている */
export function isIosAppUserAgent(ua) {
  return /iOS_App/.test(ua || '')
}

/** 実行環境の UA。navigator が無い環境（テスト・SSR）では空文字 */
export function currentUserAgent() {
  return typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''
}
